import { CommonData } from '../common_schema'

export const pdScheduleData: CommonData[] = [
  {
    name: 'Scheduler operator create(total)',
    mean: 'PD_Scheduler_operator_create:total.values.mean',
    std: 'PD_Scheduler_operator_create:total.values.std',
    location: 'PD --> Operator --> Scheduler operator create'
  },
  {
    name: 'Scheduler operator finish(total)',
    mean: 'PD_Scheduler_operator_finish:total.values.mean',
    std: 'PD_Scheduler_operator_finish:total.values.std',
    location: 'PD --> Operator --> Scheduler operator finish'
  },
  {
    name: 'Scheduler operator timeout(total)',
    mean: 'PD_Scheduler_operator_timeout:total.values.mean',
    std: 'PD_Scheduler_operator_timeout:total.values.std',
    location: 'PD --> Operator --> Scheduler operator timeout'
  },
  {
    name: 'Balance leader movement(summary for in+out)',
    mean: 'PD_Balance_leader_movement:total.values.mean',
    std: 'PD_Balance_leader_movement:total.values.std',
    location: 'PD --> Scheduler --> Balance leader movement'
  },
  {
    name: 'Balance Region movement(summary for in+out)',
    mean: 'PD_Balance_region_movement:total.values.mean',
    std: 'PD_Balance_region_movement:total.values.std',
    location: 'PD --> Scheduler --> Balance Region movement'
  },
  {
    name: 'Number of running schedulers',
    mean: 'PD_running_scheduler:total.values.mean',
    std: 'PD_running_scheduler:total.values.std',
    location: `PD --> Operator --> Scheduler is running<br />
		<br />
		[manual]<br />
		1. Check if any named scheduler has 0.<br />
		2. Check if any scatter-range scheduler running.<br />
		3. Check if any evict-leader-scheduler running.`
  },
  {
    name: `Impact to top level's Duration and QPS?`,
    mean: '[manual]',
    std: '[manual]',
    location: '[manual]'
  }
]
